import React from "react";

export default function AppCard({ className = "", children, ...rest }) {
  const classes = ["ds-card", className].filter(Boolean).join(" ");

  return (
    <section className={classes} {...rest}>
      {children}
    </section>
  );
}
